import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HoldingsListStyles = makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      padding: "10px",
    },
    rowColor: {
      "&:nth-of-type(odd)": {
        backgroundColor: "white",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#f8f9f9",
      },
    },
    copyButton: {
      display: "flex",
      backgroundColor: "#FFFF",
      textAlign: "center",
      alignSelf: "center",
      justifyContent: "flex-end",
      cursor: "pointer",
      fontWeight: 400,
    },

    verifyButton: {
      display: "flex",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      textAlign: "center",
      alignSelf: "center",
      justifyContent: "flex-end",
      cursor: "pointer",
      fontWeight: 400,
      "&.Mui-disabled": {
        backgroundColor: "lightgray",
        color: "gray",
        cursor: "not-allowed",
      },
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    tableContainer: {
      minHeight: "100px",
      borderRadius: "12px",
      marginBottom: "10px",
      paddingLeft: " 0px",
      paddingRight: "0px",
      overflow: "auto",
    },
    title: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#000000",
    },
    address: {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium,
    },
    description: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
    },
    quantityContainer: {},
    quantity: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000000",
    },
    format: { fontSize: "16px", fontWeight: 600 },
    icon: {
      display: "flex",
      alignItems: "center",
    },
    valuePercentageContainer: {},
    value: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#000000",
      textAlign: "right",
    },
    change: {
      textAlign: "right",
      "@media (max-width:400px)": {
        fontSize: "16px",
      },
    },

    paper: {
      width: "100%",
      borderRadius: "12px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      marginBottom: "30px",
      overflow: "auto",
    },
    loading: {
      width: "100%",
      height: "70vh",
      borderRadius: "12px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      marginBottom: "30px",
    },
    table: {
      width: "100%",
      height: "100%",
      borderCollapse: "collapse",
      "& .MuiTableCell-root": {
        padding: "8px",
        fontSize: "0.875rem",
      },
    },
    tableRow: {
      borderTop: "1px solid silver",
      cursor: "pointer",
      maxHeight: "30px",
    },
    tableHeadItem: {
      padding: "20px 20px",
      "&:first-child": {
        padding: "20px 0px",
        paddingLeft: "30px",
      },
    },
    gains: {
      color: "#01C0AA",
      fontSize: "16px",
    },
    loses: {
      color: "#EA0C01",
      fontSize: "16px",
    },
    buttonText: {
      fontSize: "14px",
    },
    buttonContainer: {
      minHeight: "33px",
      width: "152px",
      color: "#FFFFFF",
      textTransform: "none",
      borderRadius: "12px",
      backgroundColor: "light-grey",
      border: "none",
      fontSize: "16px",
      fontWeight: 600,
      "&:hover": {
        backgroundColor: "#7c565a",
        border: "none",
      },
    },
  }),
);
